import Vue from "vue"

// Send event globally to have access in app
export const EventBus: Vue = new Vue()
